import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import moment from "moment-timezone";
import axios from "axios";
import Home from "../assets/SVG/buttons/Home-button-big.svg";
import Profile from "../assets/SVG/icons/Avatar.svg";
import BackIcon from "../assets/SVG/buttons/back-button.svg";
import "../styles/alert.css";
import { getAlertById, getUserDetail } from "../api";
import * as action from "../actions";
import config from "../config";
axios.defaults.withCredentials = true;

const Alert = (props) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const [isLoading, setLoading] = useState(true);
  const [alert, setAlert] = useState({});
  const { alertId } = useParams();
  useEffect(() => {
    getAlertById(alertId).then( res => {
        setAlert(res.alert);
        setLoading(false);
    })
    makeAlertReadById(alertId);
  }, [])

  const makeAlertReadById = async (alertId) => {
    // update the alert to read.
    const alertResp = await axios.post(config.backend_url + `/alert/read`, {
      alertId,
    });

    // Update on user object with latest alerts
    const updatedUser = await getUserDetail();
    dispatch(action.updateUser(updatedUser.userInfo));

  };
  return (
    <div className="container">
      {isLoading ? <div id="homepage-loading" data-testid="homepage-loading"></div> : <></>}
      <div className="main navigation" data-testid="alert">
        <div className="header mt-3">
          <img src={BackIcon} alt="go-back" onClick={() => props.history.goBack()} data-testid="go-back"></img>
          <img
            src={user?.picture ? user.picture : Profile}
            alt="profile"
            data-testid="go-navigation"
            className="profile mt-4"
            onClick={() => props.history.push("/navigation")}
          ></img>
          <img src={Home} alt="home" onClick={() => props.history.push("/home")} data-testid="go-home"></img>
        </div>
        <div className="alert-detail-wrapper">
          <div className="alert-detail-title">{alert?.title && alert.title}</div>
          <div className="alert-detail-date">{alert?.createdAt && moment(alert.createdAt).tz(user?.timezone || config.defaultTimezone).format('DD/MM/YYYY LT')}</div>
          <div className="alert-detail-message">{alert?.message && alert.message}</div>
        </div>
      </div>
    </div>
  );
};

export default Alert;
